import script from "./CompetitionSinglePublic.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionSinglePublic.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/clubstyle.css?vue&type=style&index=0&lang=css&external"
import "./CompetitionSinglePublic.vue?vue&type=style&index=1&id=47977535&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47977535"]])

export default __exports__